module.exports = new __parcel__URL__("snare_6.109bef8f.mp3").toString();